
import Vue from "vue";
import {StructureArgument} from "@/utils/scripts/report-engine-script-structure-argument";
import { ISelectItem } from "winfakt-vue-components";
import { StructureColumn, StructureColumnType } from "@/utils/scripts/report-engine-script-structure-column";

export default Vue.extend({
	data(){
		return {
			structure: new StructureArgument()
		};
	},
	props: {
		value: {
			type: String,
			required: true
		}
	},
	computed: {
		types():ISelectItem<StructureColumnType>[]{
			return [
				{
					text: "string",
					value: "string"
				},
				{
					text: "date",
					value: "date",
				},
				{
					text: "float",
					value: "float"
				},
				{
					text: "int",
					value: "int"
				},
				{
					text: "bool",
					value: "bool"
				},
				{
					text: "long string",
					value: "long string"
				}
			];
		}
	},
	watch: {
		structure: {
			deep: true,
			handler(){
				this.$emit("input", JSON.stringify(this.structure.getJSON()));
			}
		}
	},
	methods: {
		add(){
			this.structure.columns.push(new StructureColumn());
		},
		remove(i:number){
			this.structure.columns.splice(i,1);
		}
	},
	mounted(){
		this.structure = new StructureArgument(JSON.parse(this.value || "{}") || {});
	}
});
